import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ArrowRightIcon, Body2, Header3, ProjectsIcon } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { getProjectById } from "~/store/selectors/selector.projects";
import { getCountAllTaskListsByProjectId } from "~/store/selectors/selector.taskLists";

const ProjectLink = ({ id, className }) => {
  const { t } = useTranslation();
  const project = useSelector((state) => getProjectById(state, id));
  const countTaskLists = useSelector((state) => getCountAllTaskListsByProjectId(state, id));
  return (
    <Link
      to={`/projects/${id}`}
      className="tw-no-underline"
    >
      <div
        className={classNames(
          "tw-flex tw-justify-between tw-items-center tw-border tw-border-solid tw-border-border-primary tw-rounded-lg tw-py-2 tw-pl-4 tw-pr-3",
          className
        )}
      >
        <div className="tw-flex tw-gap-3 tw-items-center">
          <ProjectsIcon />
          <div>
            <Header3>{project?.name}</Header3>
            <Body2>
              {countTaskLists} {t("task lists")}, {project?.count_tasks} {t("tasks")}, {project?.members.size}{" "}
              {t("project members")}
            </Body2>
          </div>
        </div>
        <ArrowRightIcon />
      </div>
    </Link>
  );
};

ProjectLink.propTypes = {
  id: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default ProjectLink;
